import Vue from 'vue'
import Router from 'vue-router'
import Layout from "@/layouts";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      component: Layout,
      redirect: "editorialBoard",
      children: [
        {
          path: "editorialBoard",
          name: "EditorialBoard",
          component: () => import("@/views/editorialBoard/index")
        },
        
      ],
    },
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "home",
          name: "Home",
          component: () => import("@/views/home/index")
        },
        
      ],
    },
    {
      path: "/focusAndScope",
      component: Layout,
      children: [
        {
          path: "/focusAndScope",
          name: "FocusAndScope",
          component: () => import("@/views/focusAndScope/index")
        },
      ],
    },
    {
      path: "/peerReiew",
      component: Layout,
      children: [
        {
          path: "/peerReiew",
          name: "PeerReiew",
          component: () => import("@/views/peerReiew/index")
        },
      ],
    },
    {
      path: "/reiewProcess",
      component: Layout,
      children: [
        {
          path: "/reiewProcess",
          name: "ReiewProcess",
          component: () => import("@/views/reiewProcess/index")
        },
      ],
    },
    {
      path: "/openAccess",
      component: Layout,
      children: [
        {
          path: "/openAccess",
          name: "OpenAccess",
          component: () => import("@/views/openAccess/index")
        },
      ],
    },
    {
      path: "/aboutThePublisher",
      component: Layout,
      children: [
        {
          path: "/aboutThePublisher",
          name: "AboutThePublisher",
          component: () => import("@/views/aboutThePublisher/index")
        },
      ],
    },
    {
      path: "/contactUs",
      component: Layout,
      children: [
        {
          path: "/contactUs",
          name: "ContactUs",
          component: () => import("@/views/contactUs/index")
        },
      ],
    },
    {
      path: "/submissionGuidelines",
      component: Layout,
      children: [
        {
          path: "/submissionGuidelines",
          name: "SubmissionGuidelines",
          component: () => import("@/views/submissionGuidelines/index")
        },
      ],
    },
    {
      path: "/onlineFirst",
      component: Layout,
      children: [
        {
          path: "/onlineFirst",
          name: "OnlineFirst",
          component: () => import("@/views/issuePages/onlineFirst.vue")
        },
      ],
    },
    {
      path: "/issue202001",
      component: Layout,
      children: [
        {
          path: "/issue202001",
          name: "issue202001",
          component: () => import("@/views/issuePages/issue202001.vue")
        },
      ],
    },
    {
      path: "/issue201901",
      component: Layout,
      children: [
        {
          path: "/issue201901",
          name: "issue201901",
          component: () => import("@/views/issuePages/issue201901.vue")
        },
      ],
    },
    {
      path: "/articalDetails",
      component: Layout,
      children: [
        {
          path: "/articalDetails",
          name: "articalDetails",
          component: () => import("@/views/issuePages/articalDetails.vue")
        },
      ],
    },
    {
      path: "/articalDetails_02",
      component: Layout,
      children: [
        {
          path: "/articalDetails_02",
          name: "articalDetails_02",
          component: () => import("@/views/issuePages/articalDetails_02.vue")
        },
      ],
    },
    {
      path: "/articalDetails_03",
      component: Layout,
      children: [
        {
          path: "/articalDetails_03",
          name: "articalDetails_03",
          component: () => import("@/views/issuePages/articalDetails_03.vue")
        },
      ],
    },
    {
      path: "/articalDetails_04",
      component: Layout,
      children: [
        {
          path: "/articalDetails_04",
          name: "articalDetails_04",
          component: () => import("@/views/issuePages/articalDetails_04.vue")
        },
      ],
    },
    {
      path: "/articalDetails_05",
      component: Layout,
      children: [
        {
          path: "/articalDetails_05",
          name: "articalDetails_05",
          component: () => import("@/views/issuePages/articalDetails_05.vue")
        },
      ],
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js